var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79289 2.29289C6.40237 2.68342 6.40237 3.31658 6.79289 3.70711L14.5858 11.5L6.79289 19.2929C6.40237 19.6834 6.40237 20.3166 6.79289 20.7071C7.18342 21.0976 7.81658 21.0976 8.20711 20.7071L16.7071 12.2071C17.0976 11.8166 17.0976 11.1834 16.7071 10.7929L8.20711 2.29289C7.81658 1.90237 7.18342 1.90237 6.79289 2.29289Z",
    fill: "#181A1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.06ef5105d4ace49f0e0a8c1c82d435e6.svg";
export { ForwardRef as ReactComponent };